export default __webpack_public_path__ + "static/media/LiquidAlumina_Pipe.256.21e790d4.png";